import { FC } from 'react';
import { ControlledInput } from '../../../../../../../../components/ControlledInput/ControlledInput';
import { AUTO_DISABLE_HINT, autoDisableToInput, formatAutoDisable } from '../../../../../../../../utils/functions/autoDisable';

type TAutoDisableInputProps = {
  id: number;
  currentId: number | null;
  value?: number | null;
  name: 'newAutoDisableSuccesses' | 'newAutoDisableTimeouts';
};

// Inline table editor for an optional threshold: digits only, empty allowed (= no limit).
export const AutoDisableInput: FC<TAutoDisableInputProps> = ({ id, currentId, value, name }) =>
  currentId !== null && id === currentId ? (
    <ControlledInput
      inputStyle={{ padding: '4px 6px', color: '#2c2e35', border: '1px solid #1890ff', borderRadius: '2px', width: '64px' }}
      defaultValue={autoDisableToInput(value)}
      placeholder={AUTO_DISABLE_HINT}
      name={name}
      type={'text'}
      rules={{ maxLength: 4 }}
      transform={(text: string | undefined) => (text ? text.replace(/[^0-9]/g, '').slice(0, 4) : text)}
    />
  ) : (
    <>{formatAutoDisable(value)}</>
  );
